import { createFileRoute, Outlet } from '@tanstack/react-router';
import {
  commonSearchSchema,
  searchTextParam,
} from '@/routes/-shared/commonSearchSchema';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import z from '@/lib/zod';
import {
  optionalSearchBoolean,
  optionalSearchString,
} from '@/lib/zod-search-params';

export const priceListsSearchSchema = commonSearchSchema.extend({
  search: searchTextParam,
  companyId: optionalSearchString(),
  categoryId: optionalSearchString(),
  activeOnly: optionalSearchBoolean(),
});

export type PriceListsSearchSchema = z.infer<typeof priceListsSearchSchema>;

export const Route = createFileRoute('/protected/_layout/price-lists/_layout')({
  validateSearch: priceListsSearchSchema,
  component: PriceListsLayout,
});

function PriceListsLayout() {
  // Listing consolidato sotto `/warehouse?subTab=price-lists`: solo le
  // route detail (`/price-lists/$id`, `/price-lists/new`) restano qui
  // per la SheetView del form listino. La pagina nuda redireziona via
  // `_layout.index.tsx`.
  const { canAccessProducts, isLoading } = usePermissions();
  return (
    <RoleGuard hasAccess={canAccessProducts} isLoading={isLoading}>
      <Outlet />
    </RoleGuard>
  );
}
